'use client'

import React from 'react'
import classNames from 'classnames'
import { remixIcons } from '@/ui/icons/remixIcons'
import { flagIcons } from '@/ui/icons/flagIcons'

type IconProps = {
  name?: keyof typeof remixIcons | keyof typeof flagIcons | null
  className?: string
  parentClass?: string
  useGradient?: boolean
}

export const Icon: React.FC<IconProps> = ({
  name,
  className: classNameFromProps,
  parentClass,
  useGradient,
}) => {
  if (!name) {
    return null
  }

  const svg = remixIcons[name] ?? flagIcons[name]

  if (!svg || typeof svg !== 'string') {
    console.error(`Icon ${name} not found or invalid`)
    return null
  }

  const svgWithClasses = svg.replace(
    '<svg',
    `<svg class="${classNames('h-4 w-4', classNameFromProps)}${useGradient ? ' [&>path]:fill-[url(#softGradientBlue)]' : ''}"`,
  )

  const gradientDef = useGradient
    ? `
    <defs>
      <linearGradient id="softGradientBlue" x1="0" x2="0" y1="1" y2="0">
        <stop offset="0%" stop-color="#6EAAE9" />
        <stop offset="100%" stop-color="#2D62C4" />
      </linearGradient>
    </defs>
  `
    : ''

  const svgWithGradient = useGradient
    ? svgWithClasses.replace('</svg>', `${gradientDef}</svg>`)
    : svgWithClasses

  return <div className={parentClass} dangerouslySetInnerHTML={{ __html: svgWithGradient }}></div>
}
